"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _utils = require("@site/utils");
var _uxUtils = require("@site/ux-utils");
var _EidCodes = _interopRequireDefault(require("../../../constants/EidCodes"));
var _reactMintl = require("@godaddy/react-mintl");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const ReputableSearchExpandable = ({
  description = 'reputableSearch.description',
  iconName = 'shield-check',
  position = 'absolute',
  side = 'left',
  title = 'reputableSearch.title'
}) => {
  const [isExpanded, setIsExpanded] = (0, _react.useState)(false);
  const {
    isDesktop
  } = (0, _uxUtils.useDeviceType)();
  (0, _react.useEffect)(() => {
    if (isDesktop) {
      (0, _utils.logImpression)(_EidCodes.default.ReputableSearch.Impression);
    }
  }, []);
  const handleMouseEnter = () => {
    (0, _utils.logEvent)({
      eid: _EidCodes.default.ReputableSearch.Click,
      type: 'hover',
      properties: {}
    });
    setIsExpanded(true);
  };
  const handleMouseLeave = () => {
    setIsExpanded(false);
  };
  if (!isDesktop) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('serp-reputable-search', {
      'position-absolute': position === 'absolute',
      'position-fixed': position === 'fixed',
      'side-left': side === 'left',
      'side-right': side === 'right'
    }),
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    tabIndex: 0,
    role: "button",
    "aria-label": "Reputable Search Information",
    "data-cy": "reputable-search",
    "data-testid": "reputable-search",
    "aria-expanded": isExpanded
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "serp-reputable-search__content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "serp-reputable-search__badge"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "serp-reputable-search__icon"
  }, (0, _uxUtils.getIconAsync)({
    name: iconName,
    iconSize: 24,
    dataCy: 'reputable-search-icon',
    fill: 'currentColor'
  })), /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    className: "serp-reputable-search__title ms-2 font-weight-bold text-uppercase",
    id: title
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "serp-reputable-search__description"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "serp-reputable-search__description-inner ms-1 mb-0"
  }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: description
  })))));
};
var _default = exports.default = ReputableSearchExpandable;